import dayjs from "dayjs";
import utc from "dayjs-plugin-utc";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useDocumentTitle from "../../utils/useDocumentTitle";

import styles from "./Teams.module.scss";

import { Metric, MetricsWrapper } from "../../components/Metric";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import { Tab, Tabs } from "../../components/Tabs";
import { TableConfig } from "../../config/Config";
import { DashboardLayout } from "../../layouts/DashboardLayout";

import { useTranslation } from "react-i18next";
import AuthApi from "../../context/AuthApi";
import { useCampaign } from "../../context/campaign";
import { useNotification } from "../../context/notification";
import { apiRequest } from "../../utils/api";
import { getLocalValue } from "../../utils/auth";
import TeamsTable from "./TeamTable";

dayjs.extend(utc);

export function Teams(props) {
  useDocumentTitle(props.title);
  const { t } = useTranslation();
  const { selectedCampaign } = useCampaign();
  const [perPage, setPerPage] = useState(TableConfig.resultPerPage);

  const tableHeader = [
    { name: "u_fullname", label: t("teams.name"), width: "15%" },
    { name: "employee_id", label: t("teams.employeeId"), width: "5%" },
    { name: "department", label: t("teams.department"), width: "15%" },
    { name: "sub_functional_unit", label: t("teams.subunit"), width: "15%" },
    { name: "lastsession", label: t("teams.lastSession"), width: "15%" },
    {
      name: "upcomingsession",
      label: t("teams.upcommingSession"),
      width: "15%",
    },
  ];
  const history = useHistory();
  const Auth = useContext(AuthApi);
  const { addNotification } = useNotification();
  const [teamData, setTeamData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [offset, setOffset] = useState(1);
  const [totalData, setTotalData] = useState(0);

  const [columnName, setColumnName] = useState("u_fullname");
  const [sortOrder, setSortOrder] = useState("asc");
  const [uid] = useState(getLocalValue("uid"));

  //ascending
  //descending

  useEffect(() => {
    // fetch from getSessionDetails api
    async function fetchData() {
      setIsLoading(true);
      const response = await apiRequest.get(
        `/api/getTeamCoacheeList?campaign_id=${selectedCampaign}&uid=${uid}&page=${offset}&limit=${perPage}&columnName=${columnName}&order=${sortOrder}`
      );

      if (response.status === 200) {
        const data = response.data.data;
        const teamsList = response.data.data.teams;
        setTeamData(teamsList);
        setTotalData(data.totalData);
      } else {
        addNotification(
          t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
          "error"
        );
      }
      setIsLoading(false);
    }

    fetchData();
  }, [offset, columnName, sortOrder, perPage, uid, addNotification]);

  const handlePaginationChange = offset => {
    setOffset(offset.selected + 1);
  };

  const sortData = name => {
    setColumnName(name);
    const order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
  };

  return (
    <DashboardLayout>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <SectionTitle>{t("teams.teams")}</SectionTitle>
            {Auth.isCoach && !Auth.isCampaignAdmin && (
              <Tabs>
                <Tab
                  label={"team"}
                  tabName={t("tabs.team")}
                  defaultTab={true}
                />
                <Tab
                  label={"personal"}
                  tabName={t("tabs.personal")}
                  linkTo={`/teams/details/${uid}`}
                />
              </Tabs>
            )}
            {Auth.isCampaignAdmin && (
              <Tabs>
                <Tab
                  label={"Functional Unit"}
                  tabName={t("tabs.campaign")}
                  linkTo={"/teams/campaign"}
                />
                <Tab label={"team"} tabName={"Team"} defaultTab={true} />
              </Tabs>
            )}
            {selectedCampaign && (
              <MetricsWrapper>
                <Metric
                  label={t("teams.members")}
                  api="getTeamCoacheeCount"
                  responseKey="response.data.data.team_count"
                />
                <Metric
                  label={t("teams.coaches")}
                  api="getTeamCoachCount"
                  responseKey="response.data.data.coache_count"
                />
              </MetricsWrapper>
            )}

            <TeamsTable
              selectedCampaign={selectedCampaign}
              tableHeader={tableHeader}
              isPersonal={false}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          </Section>
        </PageContent>
      </div>
    </DashboardLayout>
  );
}
